<template>
  <v-container
    fluid
    class="shipment-details"
    :class="{ 'shipment-details--cancelled': esEnvioCancelado }"
  >
    <div class="detail-print-action no-print">
      <v-btn class="detail-print-button" @click="imprimirDetalle" v-if="false">
        <v-icon left>mdi-printer-outline</v-icon>
        Imprimir detalle
      </v-btn>
    </div>
    <div v-if="esEnvioCancelado" class="cancelled-watermark" aria-hidden="true">
      <div
        v-for="watermarkIndex in 9"
        :key="`cancelled-watermark-${watermarkIndex}`"
        class="cancelled-watermark-content"
      >
        <v-icon>mdi-cancel</v-icon>
        <span>ENVÍO CANCELADO</span>
      </div>
    </div>
    <section class="shipment-summary">
      <div class="summary-heading">
        <div class="section-title">
          <v-icon>mdi-clipboard-text-outline</v-icon>
          <div>
            <p class="section-kicker">Detalle del envío</p>
            <h2>Información de operación</h2>
          </div>
        </div>
      </div>

      <v-row dense>
        <v-col cols="12">
          <v-sheet class="operation-panel" outlined>
            <div class="panel-title">
              <v-icon>mdi-truck-fast-outline</v-icon>
              <span>Trayecto del envío</span>
            </div>
            <div
              class="shipment-route-overview"
              :class="{ 'shipment-route-overview--destination-only': !itemi.DIRECCION_REMITENTE }"
            >
              <div class="route-party route-party--origin">
                <p class="field-label">Remitente</p>
                <p class="entity-value">{{ itemi.TITULAR || itemi.REMITENTE.nombre }}</p>
                <p v-if="itemi.REMITENTE.alias" class="entity-detail">
                  {{ itemi.REMITENTE.alias }}
                </p>
                <p v-if="itemi.REMITENTE.telefono" class="entity-detail">
                  <v-icon small>mdi-phone-outline</v-icon>{{ itemi.REMITENTE.telefono }}
                </p>
              </div>
              <div v-if="itemi.DIRECCION_REMITENTE" class="route-stop route-stop--origin">
                <p class="field-label"><v-icon small>mdi-home-map-marker</v-icon>Origen</p>
                <p class="entity-value">
                  {{ itemi.DIRECCION_REMITENTE[itemi.DIRECCION_REMITENTE.length - 1].direccion }}
                </p>
                <p class="entity-detail">
                  {{ itemi.DIRECCION_REMITENTE[itemi.DIRECCION_REMITENTE.length - 1].colonia }} ·
                  {{
                    itemi.DIRECCION_REMITENTE[itemi.DIRECCION_REMITENTE.length - 1].codigopostal
                  }}
                </p>
                <p class="entity-detail">
                  {{ itemi.DIRECCION_REMITENTE[itemi.DIRECCION_REMITENTE.length - 1].municipio }},
                  {{ itemi.DIRECCION_REMITENTE[itemi.DIRECCION_REMITENTE.length - 1].estado }}
                </p>
                <p class="entity-detail">
                  {{ itemi.DIRECCION_REMITENTE[itemi.DIRECCION_REMITENTE.length - 1].pais }}
                </p>
              </div>
              <div v-if="itemi.DIRECCION_REMITENTE" class="route-truck" aria-hidden="true">
                <div class="route-progress route-progress--origin">
                  <span v-for="dotIndex in 4" :key="`origin-progress-${dotIndex}`"></span>
                </div>
                <v-icon>mdi-truck-fast-outline</v-icon>
                <div class="route-progress route-progress--destination">
                  <span v-for="dotIndex in 4" :key="`destination-progress-${dotIndex}`"></span>
                </div>
              </div>
              <div class="route-party route-party--destination">
                <p class="field-label">Destinatario</p>
                <p class="entity-value">{{ itemi.DESTINATARIO.nombre }}</p>
                <p v-if="itemi.DESTINATARIO.alias" class="entity-detail">
                  {{ itemi.DESTINATARIO.alias }}
                </p>
                <p v-if="itemi.DESTINATARIO.telefono" class="entity-detail">
                  <v-icon small>mdi-phone-outline</v-icon>{{ itemi.DESTINATARIO.telefono }}
                </p>
              </div>
              <div class="route-stop route-stop--destination">
                <p class="field-label"><v-icon small>mdi-map-marker-outline</v-icon>Destino</p>
                <p class="entity-value">
                  {{ itemi.DIRECCION[itemi.DIRECCION.length - 1].direccion }}
                </p>
                <p class="entity-detail">
                  {{ itemi.DIRECCION[itemi.DIRECCION.length - 1].colonia }} ·
                  {{ itemi.DIRECCION[itemi.DIRECCION.length - 1].codigopostal }}
                </p>
                <p class="entity-detail">
                  {{ itemi.DIRECCION[itemi.DIRECCION.length - 1].municipio }},
                  {{ itemi.DIRECCION[itemi.DIRECCION.length - 1].estado }}
                </p>
                <p class="entity-detail">
                  {{ itemi.DIRECCION[itemi.DIRECCION.length - 1].pais }}
                </p>
              </div>
            </div>
          </v-sheet>
        </v-col>

        <v-col v-if="itemi.SERVICIO_ADICIONAL" cols="12">
          <v-sheet class="operation-panel" outlined>
            <div class="panel-title">
              <v-icon>mdi-package-variant-plus</v-icon>
              <span>Servicios adicionales</span>
            </div>
            <div class="service-list">
              <p v-if="itemi.SERVICIO_ADICIONAL.correccion_direccion">
                Corrección de dirección
                <strong>
                  {{ reductorCorrecionDireccion(itemi.SERVICIO_ADICIONAL.correccion_direccion) }}
                </strong>
              </p>
              <p v-if="itemi.SERVICIO_ADICIONAL.empaque">
                Empaque <strong>{{ formateaMoneda(itemi.SERVICIO_ADICIONAL.empaque) }}</strong>
              </p>
              <p v-if="itemi.SERVICIO_ADICIONAL.rempaque">
                Reempaque <strong>{{ formateaMoneda(itemi.SERVICIO_ADICIONAL.rempaque) }}</strong>
              </p>
              <p v-if="itemi.SERVICIO_ADICIONAL.entrega_sabado">
                Entrega en sábado
                <strong>{{ formateaMoneda(itemi.SERVICIO_ADICIONAL.entrega_sabado) }}</strong>
              </p>
              <p v-if="itemi.SERVICIO_ADICIONAL.recoleccion">
                Recolección
                <strong>{{ formateaMoneda(itemi.SERVICIO_ADICIONAL.recoleccion) }}</strong>
              </p>
              <p v-if="itemi.SERVICIO_ADICIONAL.zona_expedida">
                Zona extendida
                <strong>{{ formateaMoneda(itemi.SERVICIO_ADICIONAL.zona_expedida) }}</strong>
              </p>
              <p v-if="itemi.SERVICIO_ADICIONAL.servicio_guia">
                FLAT <strong>{{ formateaMoneda(itemi.SERVICIO_ADICIONAL.servicio_guia) }}</strong>
              </p>
              <p v-if="itemi.SERVICIO_ADICIONAL.seguro">
                Seguro <strong>{{ formateaMoneda(itemi.SERVICIO_ADICIONAL.seguro) }}</strong>
                <span>
                  Valor declarado:
                  {{ formateaMoneda(itemi.SERVICIO_ADICIONAL.valorcontenido) }}
                </span>
              </p>
            </div>
          </v-sheet>
        </v-col>
      </v-row>
    </section>

    <section v-if="mensajeria.length" class="shipment-section">
      <div class="section-heading">
        <div class="section-title">
          <v-icon>mdi-truck-fast-outline</v-icon>
          <div>
            <p class="section-kicker">Traslado</p>
            <h3>Mensajería</h3>
          </div>
        </div>
        <span class="item-count">{{ mensajeria.length }} registro(s)</span>
      </div>
      <v-row dense>
        <v-col
          v-for="(item4, index4) in mensajeria"
          :key="`mensaje-${index4}`"
          cols="12"
          sm="6"
          lg="4"
        >
          <v-sheet class="shipment-card" outlined>
            <div class="shipment-card-heading">
              <v-icon>mdi-truck-fast-outline</v-icon>
              <span>Mensaje {{ index4 + 1 }}</span>
            </div>
            <dl class="data-list">
              <div><dt>Peso</dt><dd>{{ item4.pesokg }} kg</dd></div>
              <div><dt>Guía</dt><dd>{{ formateaGuia(item4.guia) }}</dd></div>
            </dl>
          </v-sheet>
        </v-col>
      </v-row>
    </section>

    <section v-if="paquetesEnvio.length" class="shipment-section">
      <div class="section-heading">
        <div class="section-title">
          <v-icon>mdi-package-variant-closed</v-icon>
          <div>
            <p class="section-kicker">Contenido</p>
            <h3>Paquetes</h3>
          </div>
        </div>
        <span class="item-count">{{ paquetesEnvio.length }} paquete(s)</span>
      </div>
      <v-row dense>
        <v-col
          v-for="(item3, index3) in paquetesEnvio"
          :key="`paquete-${index3}`"
          cols="12"
          sm="6"
          lg="4"
        >
          <v-sheet class="shipment-card" outlined>
            <div class="shipment-card-heading">
              <v-icon>mdi-package-variant-closed</v-icon>
              <span>Paquete {{ index3 + 1 }}</span>
            </div>
            <dl class="data-list">
              <div>
                <dt>Dimensiones</dt>
                <dd>{{ item3.alto }} x {{ item3.largo }} x {{ item3.ancho }} cm</dd>
              </div>
              <div><dt>Peso real</dt><dd>{{ item3.pesokg }} kg</dd></div>
              <div><dt>Peso volumétrico</dt><dd>{{ item3.pesovol }} kg</dd></div>
              <div><dt>Guía FedEx</dt><dd>{{ formateaGuia(item3.guia) }}</dd></div>
            </dl>
          </v-sheet>
        </v-col>
      </v-row>
    </section>

    <section class="shipment-section payment-section">
      <div class="shipment-registration">
        <div class="shipment-registration-heading">
          <v-icon small>mdi-clipboard-text-outline</v-icon>
          <span>Registro del envío</span>
        </div>
        <div class="shipment-registration-data">
          <div>
            <span>Referencia IPS</span>
            <b>{{ itemi.REFERENCIA }}</b>
          </div>
          <div>
            <span>Sucursal</span>
            <b>{{ itemi.SUCURSAL }}</b>
          </div>
          <div>
            <span>Registró el envío</span>
            <b>{{ itemi.USUARIO }}</b>
          </div>
        </div>
      </div>
      <div class="section-heading">
        <div class="section-title">
          <v-icon>mdi-cash-multiple</v-icon>
          <div>
            <p class="section-kicker">Cobranza</p>
            <h3>Abonos</h3>
          </div>
        </div>
      </div>
      <div class="payment-stack">
        <v-sheet class="payment-summary">
            <div class="payment-summary-heading">
              <v-icon>mdi-cash-multiple</v-icon>
              <span>Resumen de cobranza</span>
            </div>
            <p class="payment-total-label">Total del envío</p>
            <strong class="payment-total">{{ formateaMoneda(itemi.ABONOS.total) }}</strong>
            <div class="payment-details">
              <div class="payment-detail">
                <span>Estatus de pago</span>
                <v-chip class="payment-status" small label>
                  {{ itemi.ESTADO || 'Sin estatus' }}
                </v-chip>
              </div>
              <div class="payment-detail">
                <span>Tipo de envío</span>
                <b>{{ itemi.DETALLE_ENVIO || 'No especificado' }}</b>
              </div>
            </div>
            <div class="payment-debt">
              <span>Deuda actual</span>
              <b>{{ formateaMoneda(calculaDeudaActual(itemi.ABONOS)) }}</b>
            </div>
        </v-sheet>
        <v-sheet
          v-for="(item2, index2) in itemi.ABONOS.Abonos"
          :key="`abono-${index2}`"
          class="payment-record"
          outlined
        >
          <div class="shipment-card-heading">
            <v-icon>mdi-cash-check</v-icon>
            <span>Abono {{ index2 + 1 }}</span>
          </div>
          <dl class="data-list">
            <div><dt>Fecha</dt><dd>{{ item2.fecha }}</dd></div>
            <div><dt>Importe</dt><dd>{{ formateaMoneda(item2.cantidad) }}</dd></div>
            <div><dt>Método</dt><dd>{{ item2.tipo_pago }}</dd></div>
            <div><dt>Registró</dt><dd>{{ item2.usuario.nombre }}</dd></div>
          </dl>
          <v-btn
            class="reprint-button no-print"
            outlined
            block
            @click="reimprimirAbono(item2)"
          >
            <v-icon small left>mdi-printer-outline</v-icon>Reimprimir abono
          </v-btn>
        </v-sheet>
      </div>
    </section>

    <section v-if="esEnvioInternacional" class="shipment-section tariff-section">
      <div class="section-heading">
        <div class="section-title">
          <v-icon>mdi-file-document-outline</v-icon>
          <div>
            <p class="section-kicker">Documentación internacional</p>
            <h3>Fracciones arancelarias</h3>
          </div>
        </div>
      </div>
      <v-row dense>
        <v-col
          v-for="(el, i) in paquetesEnvio"
          :key="`fraccion-${i}`"
          cols="12"
          lg="6"
        >
          <v-sheet class="tariff-panel" outlined>
            <div class="shipment-card-heading">
              <v-icon>mdi-file-document-outline</v-icon>
              <span>Paquete {{ i + 1 }}</span>
            </div>
            <div v-for="(fraccion, j) in el.fa" :key="j" class="tariff-item">
              <strong>{{ fraccion.id }} · {{ fraccion.nombre }}</strong>
              <span>{{ fraccion.num_clasificacion }}</span>
              <p>{{ fraccion.des_en }}</p>
              <p>
                Cantidad: {{ fraccion.cantidad }} - Valor unitario: {{ fraccion.valor_unitario }}
              </p>
            </div>
          </v-sheet>
        </v-col>
      </v-row>
    </section>
  </v-container>
</template>
<script>
import { FormatoMoneda, FormatoGuia } from '@/Utils/Utils';

export default {
  props: {
    itemi: Object,
  },
  computed: {
    paquetesEnvio() {
      const paquetes = this.itemi && this.itemi.PAQUETES;
      return paquetes && Array.isArray(paquetes.InfoPaquetes) ? paquetes.InfoPaquetes : [];
    },
    mensajeria() {
      const paquetes = this.itemi && this.itemi.PAQUETES;
      return paquetes && Array.isArray(paquetes.InfoMensajeria)
        ? paquetes.InfoMensajeria
        : [];
    },
    esMismoClienteRemitente() {
      const cliente = this.itemi.REMITENTE.nombre;
      const remitente = this.itemi.TITULAR || cliente;
      return cliente === remitente;
    },
    esEnvioInternacional() {
      return (
        this.itemi.DETALLE_ENVIO === 'Internacional Priority'
        || this.itemi.DETALLE_ENVIO === 'Internacional Economy'
      );
    },
    esEnvioCancelado() {
      return this.itemi && this.itemi.ESTADO === 'Cancelado';
    },
  },
  methods: {
    formateaMoneda(moneda) {
      return FormatoMoneda.format(moneda);
    },
    reductorCorrecionDireccion(arrCostoDirecciones) {
      return arrCostoDirecciones.reduce(
        (total, costoDireccion) => total + parseFloat(costoDireccion),
        0,
      );
    },
    formateaGuia(guia) {
      return FormatoGuia(guia);
    },
    calculaDeudaActual(abonos) {
      const pagosHechos = abonos.Abonos.reduce(
        (total, abono) => total + parseFloat(abono.cantidad),
        0,
      );
      const deudaActual = parseFloat(abonos.total) - parseFloat(pagosHechos);
      return deudaActual;
    },
    imprimirDetalle() {
      this.$emit('imprimir-detalle');
    },
    reimprimirAbono(abono) {
      this.$emit('reimprimir-abono', {
        fechaAbono: abono.fecha,
        cantidadAbonada: abono.cantidad,
        referencia: this.itemi.REFERENCIA,
        costoTotalEnvio: this.itemi.ABONOS.total,
        deudaActualEnvio: this.calculaDeudaActual(this.itemi.ABONOS),
        abonante: this.itemi.REMITENTE.nombre,
        totalAbonado:
          this.itemi.ABONOS.total - this.calculaDeudaActual(this.itemi.ABONOS),
      });
    },
  },
};
</script>
<style lang="css">
.shipment-details-expanded {
  background: #e8f0fa;
}

.shipment-details {
  background: #e8f0fa;
  border: 0;
  border-radius: 18px;
  color: #244b6b;
  display: grid;
  font-family: "Open Sans", sans-serif;
  gap: 20px;
  margin: 20px auto;
  max-width: 1380px;
  padding: 24px !important;
  position: relative;
  grid-template-columns: minmax(0, 1fr) minmax(300px, 0.42fr);
  width: 100%;
}

.detail-print-action {
  display: flex;
  grid-column: 1 / -1;
  justify-content: flex-end;
  margin: 0;
}

.detail-print-button {
  background: #1976d2 !important;
  border-radius: 8px !important;
  box-shadow: 0 8px 16px rgba(25, 118, 210, 0.2);
  color: #fff !important;
  font-weight: 800;
}

.detail-print-button .v-icon {
  color: #fff !important;
}

.cancelled-watermark {
  bottom: 0;
  display: grid;
  gap: 44px 54px;
  grid-template-columns: repeat(3, minmax(180px, 1fr));
  justify-items: center;
  left: 0;
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 76px;
  z-index: 4;
}

.cancelled-watermark-content {
  align-items: center;
  align-self: center;
  border: 3px solid rgba(198, 40, 40, 0.2);
  border-radius: 8px;
  color: rgba(198, 40, 40, 0.34);
  display: inline-flex;
  font-size: 18px;
  font-weight: 900;
  gap: 8px;
  justify-self: center;
  line-height: 1;
  padding: 7px 12px;
  white-space: nowrap;
  width: max-content;
  transform: rotate(-12deg);
}

.cancelled-watermark-content .v-icon {
  color: rgba(198, 40, 40, 0.34);
  font-size: 21px;
}

.shipment-details--cancelled {
  background: #fff0f0;
  color: #7c2d2d;
}

.shipment-details--cancelled .shipment-summary,
.shipment-details--cancelled .shipment-section {
  background: #fffafa;
  box-shadow: 0 12px 28px rgba(170, 45, 45, 0.1);
}

.shipment-details--cancelled .summary-heading,
.shipment-details--cancelled .section-heading,
.shipment-details--cancelled .route-party-grid,
.shipment-details--cancelled .panel-title,
.shipment-details--cancelled .shipment-card-heading,
.shipment-details--cancelled .payment-details,
.shipment-details--cancelled .payment-registration {
  border-color: #f2cccc;
}

.shipment-details--cancelled .operation-panel,
.shipment-details--cancelled .shipment-card,
.shipment-details--cancelled .payment-record,
.shipment-details--cancelled .tariff-panel,
.shipment-details--cancelled .payment-summary,
.shipment-details--cancelled .shipment-registration {
  background: #fff7f7;
  border-color: #f2cccc !important;
}

.shipment-details--cancelled .section-title .v-icon,
.shipment-details--cancelled .shipment-registration-heading,
.shipment-details--cancelled .payment-summary-heading,
.shipment-details--cancelled .payment-debt {
  background: #ffe2e2;
}

.shipment-details--cancelled .section-kicker,
.shipment-details--cancelled .reference-block strong,
.shipment-details--cancelled .section-title .v-icon,
.shipment-details--cancelled .panel-title .v-icon,
.shipment-details--cancelled .shipment-card-heading .v-icon,
.shipment-details--cancelled .field-label .v-icon,
.shipment-details--cancelled .entity-detail .v-icon,
.shipment-details--cancelled .payment-summary-heading,
.shipment-details--cancelled .payment-summary-heading .v-icon,
.shipment-details--cancelled .shipment-registration-heading,
.shipment-details--cancelled .shipment-registration-heading .v-icon,
.shipment-details--cancelled .payment-total,
.shipment-details--cancelled .payment-debt b,
.shipment-details--cancelled .tariff-item span {
  color: #c62828;
}

.shipment-details--cancelled .route-truck .v-icon {
  background: #c62828;
  color: #fff;
}

.shipment-details--cancelled .summary-heading h2,
.shipment-details--cancelled .section-heading h3,
.shipment-details--cancelled .panel-title,
.shipment-details--cancelled .shipment-card-heading,
.shipment-details--cancelled .entity-value,
.shipment-details--cancelled .data-list dd,
.shipment-details--cancelled .payment-detail b,
.shipment-details--cancelled .payment-registration b,
.shipment-details--cancelled .tariff-item strong {
  color: #7c2d2d;
}

.shipment-details--cancelled .field-label,
.shipment-details--cancelled .entity-detail,
.shipment-details--cancelled .data-list dt,
.shipment-details--cancelled .payment-detail > span,
.shipment-details--cancelled .payment-total-label,
.shipment-details--cancelled .payment-debt span,
.shipment-details--cancelled .payment-registration span,
.shipment-details--cancelled .tariff-item {
  color: #9d5151;
}

.shipment-details--cancelled .payment-status {
  background: #ffe2e2 !important;
  color: #c62828 !important;
}

.shipment-details--cancelled .detail-print-button,
.shipment-details--cancelled .reprint-button {
  background: #c62828 !important;
  border-color: #c62828 !important;
}

.shipment-details--cancelled .reprint-button:hover {
  background: #9f1f1f !important;
  border-color: #9f1f1f !important;
}

.shipment-summary,
.shipment-section {
  background: #fff;
  border: 0;
  border-radius: 14px;
  box-shadow: 0 12px 28px rgba(48, 95, 142, 0.1);
  grid-column: 1;
  margin: 0;
  overflow: hidden;
  padding: 22px;
}

.summary-heading,
.section-heading {
  align-items: center;
  background: transparent;
  border-bottom: 1px solid #dce8f5;
  color: #244b6b;
  display: flex;
  justify-content: space-between;
  margin: 0 0 20px;
  padding: 0 0 16px;
}

.section-title {
  align-items: center;
  display: flex;
  gap: 12px;
}

.section-title .v-icon {
  background: #e3f0fe;
  border-radius: 8px;
  color: #1976d2;
  padding: 7px;
}

.section-kicker {
  color: #1976d2;
  font-size: 12px;
  font-weight: 700;
  margin: 0 0 4px;
}

.summary-heading h2,
.section-heading h3 {
  color: #244b6b;
  font-family: Poppins, "Open Sans", sans-serif;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 1.2;
  margin: 0;
}

.summary-heading h2 {
  font-size: 24px;
}

.section-heading h3 {
  font-size: 18px;
}

.reference-block,
.item-count {
  color: #5d7d9b;
  font-size: 12px;
  font-weight: 700;
}

.reference-block {
  text-align: right;
}

.reference-block span,
.reference-block strong {
  display: block;
}

.reference-block strong {
  color: #1976d2;
  font-size: 14px;
  font-weight: 800;
}

.header-metadata {
  align-items: center;
  display: flex;
  font-size: 11px;
  font-weight: 600;
  gap: 4px;
  justify-content: flex-end;
  margin: 4px 0 0;
}

.header-metadata .v-icon {
  color: #1976d2;
}

.operation-panel,
.shipment-card,
.payment-record,
.tariff-panel {
  background: #f8fbff;
  border: 1px solid #dce8f5 !important;
  border-radius: 10px;
  height: 100%;
  overflow: hidden;
  padding: 18px;
}

.operation-panel:hover,
.shipment-card:hover,
.payment-record:hover,
.tariff-panel:hover {
  border-color: #8fc2ed !important;
  box-shadow: 0 8px 18px rgba(48, 95, 142, 0.1);
}

.panel-title,
.shipment-card-heading {
  align-items: center;
  background: transparent;
  border-bottom: 1px solid #dce8f5;
  color: #244b6b;
  display: flex;
  font-size: 13px;
  font-weight: 800;
  gap: 8px;
  margin: -18px -18px 16px;
  padding: 10px 14px;
}

.panel-title .v-icon,
.shipment-card-heading .v-icon,
.entity-detail .v-icon,
.field-label .v-icon {
  color: #1976d2;
}

.operation-grid {
  margin: 0;
}

.shipment-route-overview {
  align-items: center;
  display: grid;
  column-gap: 20px;
  grid-template-areas:
    "origin-party truck destination-party"
    "origin-stop truck destination-stop";
  grid-template-columns: minmax(0, 1fr) minmax(180px, 0.42fr) minmax(0, 1fr);
  row-gap: 24px;
  padding: 8px 12px;
}

.route-party {
  text-align: center;
}

.route-party--origin {
  grid-area: origin-party;
}

.route-party--destination {
  grid-area: destination-party;
}

.route-party .field-label,
.route-party .entity-detail {
  justify-content: center;
}

.shipment-route-overview--destination-only {
  grid-template-areas:
    "origin-party destination-party"
    "destination-stop destination-stop";
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.route-truck {
  align-items: center;
  display: flex;
  gap: 9px;
  grid-area: truck;
  justify-content: center;
}

.route-progress {
  align-items: center;
  display: flex;
  gap: 6px;
}

.route-progress span {
  background: #1976d2;
  border-radius: 50%;
  display: block;
  height: 5px;
  width: 5px;
}

.route-progress--origin span:nth-child(1),
.route-progress--destination span:nth-child(4) {
  opacity: 0.18;
}

.route-progress--origin span:nth-child(2),
.route-progress--destination span:nth-child(3) {
  opacity: 0.36;
}

.route-progress--origin span:nth-child(3),
.route-progress--destination span:nth-child(2) {
  opacity: 0.6;
}

.route-progress--origin span:nth-child(4),
.route-progress--destination span:nth-child(1) {
  opacity: 0.9;
}

.route-truck .v-icon {
  background: #1976d2;
  border-radius: 50%;
  color: #fff;
  font-size: 19px;
  padding: 9px;
}

.route-stop--destination {
  grid-area: destination-stop;
  text-align: center;
}

.route-stop--destination .entity-detail {
  justify-content: center;
}

.route-stop--origin .entity-detail {
  justify-content: center;
}

.route-stop--origin {
  grid-area: origin-stop;
}

.route-stop--origin,
.route-stop--destination {
  padding: 6px 18px;
  text-align: center;
}

.route-stop--origin .field-label,
.route-stop--destination .field-label {
  color: #1976d2;
  justify-content: center;
}

.entity-block,
.route-stop {
  height: 100%;
}

.entity-block {
  padding: 6px 12px;
}

.field-label,
.entity-value,
.entity-detail {
  margin: 0;
}

.field-label {
  align-items: center;
  color: #5d7d9b;
  display: flex;
  font-size: 12px;
  font-weight: 700;
  gap: 5px;
}

.field-label .v-icon {
  color: #1976d2;
}

.entity-value {
  color: #244b6b;
  font-size: 15px;
  font-weight: 700;
  margin-top: 5px;
}

.entity-detail {
  align-items: center;
  color: #5d7d9b;
  display: flex;
  font-size: 13px;
  font-weight: 700;
  gap: 6px;
  margin-top: 5px;
}

.entity-detail .v-icon {
  color: #1976d2;
}

@media (min-width: 960px) {
  .operation-grid > * + * {
    border-left: 1px solid #dce8f5;
  }

  .payment-section {
    grid-column: 2;
    grid-row: 2 / span 4;
    position: sticky;
    top: 20px;
  }
}

.service-list p {
  align-items: baseline;
  border-top: 1px solid #e7f0f9;
  color: #5d7d9b;
  display: flex;
  font-size: 13px;
  font-weight: 700;
  justify-content: space-between;
  margin: 0;
  padding: 7px 0;
}

.service-list p:first-child {
  border-top: 0;
  padding-top: 0;
}

.service-list strong {
  color: #244b6b;
  margin-left: 12px;
  text-align: right;
}

.service-list span {
  display: block;
  font-size: 11px;
  font-weight: 700;
  margin-left: auto;
  text-align: right;
}

.data-list {
  margin: 0;
}

.data-list div {
  align-items: baseline;
  border-top: 1px solid #e7f0f9;
  display: flex;
  font-size: 13px;
  font-weight: 700;
  justify-content: space-between;
  padding: 9px 0;
}

.data-list div:first-child {
  border-top: 0;
  padding-top: 0;
}

.data-list div:last-child {
  padding-bottom: 0;
}

.data-list dt {
  color: #5d7d9b;
  font-weight: 700;
}

.data-list dd {
  color: #244b6b;
  font-weight: 700;
  margin-left: 16px;
  text-align: right;
}

.payment-summary {
  background: #f8fbff;
  border: 1px solid #dce8f5;
  border-radius: 10px;
  color: #244b6b;
  height: 100%;
  overflow: hidden;
  padding: 20px;
}

.payment-stack {
  display: grid;
  gap: 14px;
}

.payment-stack .payment-summary,
.payment-stack .payment-record {
  height: auto;
}

.payment-summary-heading {
  align-items: center;
  background: #e3f0fe;
  color: #1976d2;
  display: flex;
  font-size: 13px;
  font-weight: 700;
  gap: 8px;
  margin: -20px -20px 22px;
  padding: 12px 16px;
}

.payment-summary-heading .v-icon {
  color: #1976d2;
}

.payment-total-label {
  color: #5d7d9b;
  font-size: 13px;
  font-weight: 700;
  margin: 0;
}

.payment-total {
  color: #1976d2;
  display: block;
  font-size: 34px;
  font-weight: 900;
  line-height: 1.2;
  margin: 6px 0 18px;
}

.payment-details {
  border-top: 1px solid #e7f0f9;
  margin-bottom: 18px;
}

.payment-detail {
  align-items: center;
  border-bottom: 1px solid #e7f0f9;
  display: flex;
  justify-content: space-between;
  padding: 9px 0;
}

.payment-detail > span {
  color: #5d7d9b;
  font-size: 13px;
  font-weight: 700;
}

.payment-detail b {
  color: #244b6b;
  font-size: 13px;
  font-weight: 800;
  margin-left: 16px;
  text-align: right;
}

.payment-status {
  background: #e3f0fe !important;
  color: #1976d2 !important;
  font-size: 11px;
  font-weight: 800;
  margin-left: 16px;
}

.payment-debt {
  align-items: center;
  background: #eaf4ff;
  border: 1px solid #cce3f7;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  margin: 0;
  padding: 14px;
}

.payment-debt span {
  color: #5d7d9b;
  font-size: 13px;
  font-weight: 700;
}

.payment-debt b {
  color: #1976d2;
  font-size: 16px;
  font-weight: 900;
}

.shipment-registration {
  background: #f8fbff;
  border-bottom: 1px solid #dce8f5;
  border-radius: 8px;
  margin-bottom: 20px;
  overflow: hidden;
}

.shipment-registration-heading {
  align-items: center;
  background: #e3f0fe;
  color: #1976d2;
  display: flex;
  font-size: 13px;
  font-weight: 800;
  gap: 7px;
  padding: 10px 12px;
}

.shipment-registration-heading .v-icon {
  color: #1976d2;
}

.shipment-registration-data {
  padding: 6px 12px 10px;
}

.shipment-registration-data div {
  align-items: baseline;
  display: flex;
  font-size: 12px;
  justify-content: space-between;
  padding: 7px 0;
}

.shipment-registration-data span {
  color: #5d7d9b;
  font-weight: 700;
}

.shipment-registration-data b {
  color: #244b6b;
  font-weight: 800;
  margin-left: 12px;
  text-align: right;
}

.reprint-button {
  background: #1976d2 !important;
  border-color: #1976d2 !important;
  color: #fff !important;
  font-weight: 800;
  min-height: 44px;
  margin-top: 18px;
}

.reprint-button .v-icon {
  color: #fff !important;
}

.reprint-button:hover {
  background: #0d5cad !important;
  border-color: #0d5cad !important;
}

.reprint-button:focus::before {
  opacity: 0.2;
}

.tariff-item {
  border-top: 1px solid #e7f0f9;
  color: #5d7d9b;
  font-size: 13px;
  font-weight: 700;
  padding: 12px 0;
}

.tariff-item:first-of-type {
  border-top: 0;
  padding-top: 0;
}

.tariff-item:last-child {
  padding-bottom: 0;
}

.tariff-item strong,
.tariff-item span {
  display: block;
}

.tariff-item strong {
  color: #244b6b;
}

.tariff-item span {
  color: #1976d2;
  font-size: 12px;
  font-weight: 700;
  margin-top: 3px;
}

.tariff-item p {
  margin: 6px 0 0;
}

@media (max-width: 599px) {
  .summary-heading,
  .section-heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
  }

  .reference-block {
    text-align: left;
  }

  .data-list div,
  .service-list p {
    align-items: flex-start;
    flex-direction: column;
    gap: 3px;
  }

  .data-list dd,
  .service-list strong,
  .service-list span {
    margin-left: 0;
    text-align: left;
  }

  .shipment-route-overview {
    gap: 18px;
    grid-template-areas:
      "origin-party"
      "origin-stop"
      "truck"
      "destination-party"
      "destination-stop";
    grid-template-columns: minmax(0, 1fr);
  }

  .shipment-route-overview--destination-only {
    grid-template-areas:
      "origin-party"
      "destination-party"
      "destination-stop";
  }

  .route-truck {
    min-height: 42px;
  }

  .route-stop--origin,
  .route-stop--destination {
    padding: 0 6px;
  }
}

@media (max-width: 959px) {
  .shipment-details {
    grid-template-columns: minmax(0, 1fr);
  }

  .shipment-summary,
  .shipment-section,
  .detail-print-action {
    grid-column: 1;
  }
}

@media print {
  .no-print {
    display: none !important;
  }

  .shipment-details {
    background: #fff;
    border: 0;
    display: block;
    margin: 0;
    max-width: none;
    padding: 0 !important;
    width: 100%;
  }

  .shipment-summary,
  .shipment-section {
    margin-bottom: 16px;
    overflow: visible;
  }

  .operation-panel,
  .shipment-card,
  .payment-record,
  .payment-summary,
  .tariff-panel {
    break-inside: avoid;
  }

  .summary-heading,
  .section-heading,
  .panel-title,
  .shipment-card-heading,
  .payment-summary-heading {
    break-after: avoid;
  }
}
</style>
